import { render, staticRenderFns } from "./ViewCommentContainer.vue?vue&type=template&id=7e6fd55a&scoped=true"
import script from "./ViewCommentContainer.vue?vue&type=script&lang=js"
export * from "./ViewCommentContainer.vue?vue&type=script&lang=js"
import style0 from "./ViewCommentContainer.vue?vue&type=style&index=0&id=7e6fd55a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6fd55a",
  null
  
)

export default component.exports